import { render } from "./OrderTripsList.vue?vue&type=template&id=27603e70&scoped=true"
import script from "./OrderTripsList.vue?vue&type=script&lang=js"
export * from "./OrderTripsList.vue?vue&type=script&lang=js"

import "./OrderTripsList.vue?vue&type=style&index=0&id=27603e70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27603e70"]])

export default __exports__